"use client";
import { n as clsx, t as extendTailwindMerge } from "./vendor-styling-ngocy1lirv3frm2y.js";
//#endregion
//#region src/utils/cn.ts
/**
* Atoms typography utilities (`text-{family}-{size}`) come from the `--text-*`
* theme tokens. tailwind-merge's default config doesn't know these custom
* values, so its greedy `text-color` group swallows them — making
* `cn('text-od-content-primary', 'text-display-lg')` drop the color (the two
* land in the same conflict group). Registering them as explicit members of the
* `font-size` group keeps typography and text-color in separate groups: exact
* class matches are resolved before the `text-color` validator, so
* `text-display-lg` → font-size and `text-od-*` → text-color.
*
* The class list is generated from `THEME_CONFIG.typography` (the source of
* truth) by `pnpm generate:themes` → `styles/typography.generated.ts`, so it
* stays in sync with the ramp automatically.
*/
var twMerge = extendTailwindMerge({ extend: { classGroups: { "font-size": [{ text: [...[
	"display-lg",
	"display-md",
	"display-sm",
	"display-xs",
	"header-lg",
	"header-md",
	"header-sm",
	"subheader-lg",
	"subheader-md",
	"subheader-sm",
	"subheader-xs",
	"body-xl",
	"body-lg",
	"body-md",
	"body-sm",
	"label-xl",
	"label-lg",
	"label-md",
	"label-sm"
]] }] } } });
function cn(...inputs) {
	return twMerge(clsx(inputs));
}
var toHex = (n) => n.toString(16).padStart(2, "0");
function safeRandomId() {
	const c = globalThis.crypto;
	if (c && typeof c.randomUUID === "function") return c.randomUUID();
	if (c && typeof c.getRandomValues === "function") {
		const bytes = new Uint8Array(16);
		c.getRandomValues(bytes);
		bytes[6] = bytes[6] & 15 | 64;
		bytes[8] = bytes[8] & 63 | 128;
		const hex = Array.from(bytes, toHex).join("");
		return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
	}
	return `r${Math.random().toString(36).slice(2)}${Date.now().toString(36)}`;
}
//#endregion
export { safeRandomId as n, cn as t };

